import { NgModule } from 'ng-metadata/core';
import 'angular-inview';
import {PrmMoreLikeThis} from "./moreLikeThis.directive";
import {MoreLikeThisService} from "./moreLikeThis.service";
import {MoreLikeThisItemInfoService} from "./moreLikeThisItemInfo/moreLikeThisItemInfo.service";
import {PrmMoreLikeThisItem} from "./moreLikeThisItem/moreLikeThisItem.directive";
import {PrmMoreLikeThisItemInfo} from "./moreLikeThisItemInfo/moreLikeThisItemInfo.directive";
import {MoreLikeThisItemService} from "./moreLikeThisItem/moreLikeThisItem.service";

@NgModule({
    declarations: [
        PrmMoreLikeThis,
        PrmMoreLikeThisItem,
        PrmMoreLikeThisItemInfo
    ],
    providers: [
        MoreLikeThisService,
        MoreLikeThisItemService,
        MoreLikeThisItemInfoService
    ],
    imports:[
        'angular-inview'
    ]
})
export class MoreLikeThisModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/moreLikeThis/moreLikeThis.module.ts